import type {z} from "zod";

import {RenewRepresentativeContractBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

const contract = RenewRepresentativeContractBody.shape.contract;

export const renewRepresentativeContractFormSchema = zod.object({
  contractedAt: contract.shape.contractedAt,
  durationMonths: contract.shape.durationMonths,
});
export type RenewRepresentativeContractFormPayload = z.output<
  typeof renewRepresentativeContractFormSchema
>;

export const draftRenewRepresentativeContractFormSchema =
  renewRepresentativeContractFormSchema.partial();
export type DraftRenewRepresentativeContractFormPayload = z.output<
  typeof draftRenewRepresentativeContractFormSchema
>;
